let API_URL = process.env.REACT_APP_API_URL;
let API_KEY = process.env.REACT_APP_API_KEY;

export const getRoznamaByDate = async (date) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'getRoznamaByDate',
                apiKey: API_KEY,
                origin: window.location.origin,
                date: date
            }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error fetching roznama:', error);
        return { success: false, error: error.message };
    }
};

// export const saveRoznama = async (roznamadata) => {
//   try {
//     const response = await fetch(API_URL, {
//       method: 'POST',
//       body: JSON.stringify({
//         action: 'saveRoznama',
//         apiKey: API_KEY,
//         origin: window.location.origin,
//         ...roznamadata
//       }),
//     });

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error('Error saving roznama:', error);
//     return { success: false, error: error.message };
//   }
// };

// Update your roznamas.js service file
export const closeRoznamaDay = async (date, openingBalanceCash, openingBalanceBank, incomeTransactions, expenseTransactions, closingBalanceBank, closingBalanceCash, netProfit, totalIncome, totalExpense) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'closeRoznamaDay',
                apiKey: API_KEY,
                origin: window.location.origin,
                date,
                openingBalanceCash,
                openingBalanceBank,
                incomeTransactions,
                expenseTransactions,
                closingBalanceBank,
                closingBalanceCash,
                netProfit,
                totalExpense,
                totalIncome
            }),
        });

        const data = await response.json();
        return data;
    } catch (error) {
        console.error('Error closing roznama day:', error);
        return { success: false, error: error.message };
    }
};
export const addRoznamaDay = async (roznamaData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'addRoznama',
                apiKey: API_KEY,
                origin: window.location.origin,
                ...roznamaData
            }),
        });

        const jsonResponse = await response.json();
        if (jsonResponse?.success === true) {
            let data = roznamaData;
            data.id = jsonResponse?.data?.id;
            jsonResponse.data = data;
        }
        console.log('Add Roznama Response:', response);
        return jsonResponse;
    } catch (error) {
        console.error('Error closing roznama day:', error);
        return { success: false, error: error.message };
    }
};
export const updateRoznamaDay = async (id, roznamaData) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'updateRoznama',
                apiKey: API_KEY,
                origin: window.location.origin,
                ...roznamaData,
                id
            }),
        });

        const jsonResponse = await response.json();
        if (jsonResponse?.success === true) {
            let data = roznamaData;
            data.id = jsonResponse?.data?.id;
            jsonResponse.data = data;
        }
        console.log('Add Roznama Response:', response);
        return jsonResponse;
    } catch (error) {
        console.error('Error closing roznama day:', error);
        return { success: false, error: error.message };
    }
};
export const deleteRoznamaDay = async (id) => {
    try {
        const response = await fetch(API_URL, {
            method: 'POST',
            body: JSON.stringify({
                action: 'deleteRoznama',
                apiKey: API_KEY,
                origin: window.location.origin,
                id
            }),
        });

        return await response.json();
    } catch (error) {
        console.error('Error closing roznama day:', error);
        return { success: false, error: error.message };
    }
};